export default __webpack_public_path__ + "static/media/utb-symbol.a6333f48.svg";